var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import Select from "../../../ui/ButtonSelect/Select";
import Input from "../../../ui/Input/Input";
import Label from "../../../ui/Label/Label";
import { useGameContext } from "../../../game/GameContext/GameContext";
import { BetIncreaseSelect, } from "./BetIncrease.types";
import { InputContainer, InputsWrapper, SelectContainer, } from "./BetIncrease.styled";
import { InputWithLabelContainer } from "../../../game/GameContainer/GameContainer.styled";
var BetIncrease = function (_a) {
    var labelText = _a.labelText, propType = _a.propType;
    var _b = useGameContext(), autoPlayOptions = _b.autoPlayOptions, setAutoPlayOptions = _b.setAutoPlayOptions, inProgress = _b.inProgress, autoPlayInProgress = _b.autoPlayInProgress, controlPanelDisabled = _b.controlPanelDisabled;
    var isSelectDisabled = useMemo(function () { return inProgress || autoPlayInProgress || controlPanelDisabled; }, [inProgress, autoPlayInProgress, controlPanelDisabled]);
    var isDeltaWinReset = autoPlayOptions.betDeltaWinAction === BetIncreaseSelect.Reset;
    var isDeltaLossReset = autoPlayOptions.betDeltaLossAction === BetIncreaseSelect.Reset;
    var isInputDisabled = useMemo(function () {
        var isWinType = propType === "win";
        var isResetSelected = isWinType ? isDeltaWinReset : isDeltaLossReset;
        return isResetSelected || inProgress || autoPlayInProgress || controlPanelDisabled;
    }, [
        propType,
        autoPlayOptions.betDeltaWinAction,
        autoPlayOptions.betDeltaLossAction,
        inProgress,
        autoPlayInProgress,
        controlPanelDisabled,
    ]);
    var handlePlayModeChange = function (selectedOption) {
        var castedOption = selectedOption;
        setAutoPlayOptions(function (prevOptions) {
            var updatedOptions = __assign(__assign({}, prevOptions), { betDeltaWinAction: propType === "win" ? castedOption : prevOptions.betDeltaWinAction, betDeltaLossAction: propType !== "win" ? castedOption : prevOptions.betDeltaLossAction });
            return updatedOptions;
        });
    };
    var updateBetDelta = function (event) {
        var input = event.target.value;
        var value = parseInt(input || "0");
        if (isNaN(value))
            return event.preventDefault();
        if (value < 0)
            value = -value;
        if (value > 1000)
            value = Math.min(value, 1000);
        setAutoPlayOptions(function (prevOptions) {
            var betDeltaWin = prevOptions.betDeltaWin, betDeltaLoss = prevOptions.betDeltaLoss;
            var delta = propType === "win" ? betDeltaWin : betDeltaLoss;
            switch (true) {
                case delta === value:
                    return prevOptions;
                case propType === "win":
                    return __assign(__assign({}, prevOptions), { betDeltaWin: value });
                default:
                    return __assign(__assign({}, prevOptions), { betDeltaLoss: value });
            }
        });
    };
    var playModeOptions = [
        {
            option: BetIncreaseSelect.Reset,
            selected: propType === "win"
                ? isDeltaWinReset
                : isDeltaLossReset,
        },
        {
            option: BetIncreaseSelect.IncreaseBy,
            selected: propType === "win"
                ? autoPlayOptions.betDeltaWinAction === BetIncreaseSelect.IncreaseBy
                : autoPlayOptions.betDeltaLossAction === BetIncreaseSelect.IncreaseBy,
        },
    ];
    return (_jsxs(InputWithLabelContainer, { children: [_jsx(Label, { children: labelText }), _jsxs(InputsWrapper, { children: [_jsx(SelectContainer, { children: _jsx(Select, { variant: "default", options: playModeOptions, onChange: handlePlayModeChange, disabled: isSelectDisabled }) }), _jsx(InputContainer, { children: _jsx(Input, { type: "number", variant: "default", value: propType === "win"
                                ? autoPlayOptions.betDeltaWin.toString()
                                : autoPlayOptions.betDeltaLoss.toString(), placeholder: "0", onChange: updateBetDelta, rightContent: "%", disabled: isInputDisabled }) })] })] }));
};
BetIncrease.displayName = "BetIncrease";
export default BetIncrease;
//# sourceMappingURL=BetIncrease.js.map